/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'doT',
	'text!./templates/TextWidgetColorSet.html'
], (dot, templateString) => {
	class TextWidgetColorSet {
		static getColorStyles(colorService, paletteId) {
			return Promise.all([
				colorService.getForegroundCSSColors('ForegroundUserPaletteColor', paletteId),
				colorService.getForegroundCSSColors('TextWidgetColor1UserPaletteColor', paletteId),
				colorService.getForegroundCSSColors('TextWidgetColor2UserPaletteColor', paletteId),
				colorService.getForegroundCSSColors('TextWidgetColor3UserPaletteColor', paletteId),
				colorService.getForegroundCSSColors('TextWidgetColor4UserPaletteColor', paletteId)
			]).then(([foregroundColors, foregroundTextWidgetColor1, foregroundTextWidgetColor2, foregroundTextWidgetColor3, foregroundTextWidgetColor4]) => {
				return TextWidgetColorSet.dotTemplate({
					colors: colorService.getColorSet(paletteId),
					foregroundColors: foregroundColors,
					foregroundTextWidgetColor1: foregroundTextWidgetColor1,
					foregroundTextWidgetColor2: foregroundTextWidgetColor2,
					foregroundTextWidgetColor3: foregroundTextWidgetColor3,
					foregroundTextWidgetColor4: foregroundTextWidgetColor4
				});
			});
		}
	}

	TextWidgetColorSet.dotTemplate = dot.template(templateString);

	return TextWidgetColorSet;
});
